import { companyClaimRestrictionsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const COMPANY_CLAIM_RESTRICTIONS_ACTION_TYPE = createNamedActions(
  'companyClaimRestrictions',
  {
    GET_RESTRICTIONS: 'GET_COMPANY_CLAIM_RESTRICTIONS',
    UPDATE_RESTRICTIONS: 'UPDATE_COMPANY_CLAIM_RESTRICTIONS',
  },
);

export const getCompanyClaimRestrictionsAction = catchAsyncActionError(
  ({ companyId, skipForbiddenError }) =>
    async dispatch => {
      const { data } = await companyClaimRestrictionsApi.getRestrictions({
        companyId,
        skipForbiddenError,
      });

      return dispatch({
        type: COMPANY_CLAIM_RESTRICTIONS_ACTION_TYPE.GET_RESTRICTIONS,
        payload: data,
      });
    },
);

export const updateCompanyClaimRestrictionsAction = catchAsyncActionError(
  ({ companyId, restrictedClaims }) =>
    async dispatch => {
      const { data } = await companyClaimRestrictionsApi.updateRestrictions({
        companyId,
        restrictedClaims,
      });

      return dispatch({
        type: COMPANY_CLAIM_RESTRICTIONS_ACTION_TYPE.UPDATE_RESTRICTIONS,
        payload: data,
      });
    },
);
